import { render } from "./IconCasePageCity.vue?vue&type=template&id=40204fab&scoped=true"
const script = {}

import "./IconCasePageCity.vue?vue&type=style&index=0&id=40204fab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40204fab"]])

export default __exports__